
import React, { useContext, useState } from 'react';
import { Grid, Menu, MenuItem, IconButton, CircularProgress } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ExportIdentifiedSpeciesMenuItem from './ExportIdentifiedSpeciesMenuItem';
import ExportKgASTPredictionsMenuItem from './ExportKgASTPredictionsMenuItem';
import { IdentifiedSpeciesFiltersContext } from '../context/IdentifiedSpeciesFiltersContext';


function IdentifiedSpeciesMenu(props) {
    const {
        loading,
        isIllumina,
        run,
        sample,
        setIsResistanceGeneDialogOpen,
        hasAccessExtendedResistanceGenePanel
    } = props;
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const { loadingResistanceGenes } = useContext(IdentifiedSpeciesFiltersContext);

    const open = Boolean(menuAnchorEl);
    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };
      
    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };
    const [isExporting, setIsExporting] = useState(false);

    return (
        <Grid item sx={{textAlign: 'right'}}>
            <IconButton size="small" onClick={handleMenuClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {hasAccessExtendedResistanceGenePanel &&
                    <MenuItem disabled={loading || loadingResistanceGenes} onClick={() => {
                        setIsResistanceGeneDialogOpen(true);
                        handleMenuClose();
                    }}>
                        Complete Resistance Gene Profile
                        {loadingResistanceGenes && (
                            <CircularProgress size={16} sx={{ ml: 1 }} />
                        )}
                    </MenuItem>
                }
                <ExportIdentifiedSpeciesMenuItem
                    isIllumina={isIllumina}
                    isDatasetLevel={false}
                    run={run}
                    samples={[sample]}
                    handleMenuClose={handleMenuClose}
                    oneMenuItemClicked={isExporting}
                    setOneMenuItemClicked={setIsExporting}
                />
                <ExportKgASTPredictionsMenuItem
                    isIllumina={isIllumina}
                    isDatasetLevel={false}
                    run={run}
                    samples={[sample]}
                    handleMenuClose={handleMenuClose}
                    oneMenuItemClicked={isExporting}
                    setOneMenuItemClicked={setIsExporting}
                />
            </Menu>
        </Grid>
    );
}

export default IdentifiedSpeciesMenu;